import { type CountryCode } from "@/config/country-config";

export const SILENT_AUTH_ATTEMPT_COOKIE = "lea_silent_auth_attempt";
export const SILENT_AUTH_ERROR_COOKIE = "lea_silent_auth_error";
export const SIGNING_SOURCE_COOKIE = "lea_signing_source";
export const SIGNING_SOURCE_APPLICATION = "application";

export interface SilentAuthState {
	country: CountryCode;
	fromApplication?: boolean;
	attempted?: boolean;
	status?: string | null;
	error?: string | null;
}

export const buildSilentAuthSuccessPath = (flowId: string): string =>
	`/${flowId}`;

export const buildSilentAuthUnavailablePath = (flowId: string): string =>
	`/${flowId}/login`;

/**
 * Only worth attempting on a clean first visit: an attempt cookie means one
 * already ran, and status/error mean the user has an error to act on.
 */
export const shouldAttemptSilentAuth = ({
	country,
	fromApplication,
	attempted,
	status,
	error,
}: SilentAuthState): boolean =>
	country === "FI" &&
	fromApplication === true &&
	!attempted &&
	!status &&
	!error;
